<template>
    <div class="homepage-hero-module">
        <!--<div style="position:absolute;width: 100%">-->
            <!--<v-background></v-background>-->
        <!--</div>-->

        <div class="video-container">
            <div :style="fixStyle" class="filter">
                <div class="login">
                    <div class="login-box" style="position:absolute;background-color: #fff;width: 350px; height: 400px; padding: 20px; border-radius: 10px">
                        <div style="margin: 20px 0; text-align: center; font-size: 24px"><b>登 录</b></div>
                        <el-form :model="user" :rules="rules" ref="userForm">
                            <el-form-item prop="username">
                                <el-input size="medium" style="margin: 10px 0" prefix-icon="el-icon-user" v-model="user.username" placeholder="请输入账号"></el-input>
                            </el-form-item>
                            <el-form-item prop="password">
                                <el-input size="medium" style="margin: 10px 0" prefix-icon="el-icon-lock" show-password v-model="user.password" placeholder="请输入密码"></el-input>
                            </el-form-item>
                            <el-form-item>
                                <div style="display: flex">
                                    <el-input size="medium" style="width: 180px;margin: 10px 0"prefix-icon="el-icon-key" v-model="user.validCode" placeholder="请输入验证码"></el-input>
                                    <ValidCode @input="createValidCode" />
                                </div>
                            </el-form-item>
                            <!--<el-form-item>-->
                            <!--<el-radio v-model="user.role" label="ROLE_ADMIN">管理员</el-radio>-->
                            <!--<el-radio v-model="user.role" label="ROLE_ORIGINATOR">创作者</el-radio>-->
                            <!--<el-radio v-model="user.role" label="ROLE_USER">普通用户</el-radio>-->
                            <!--</el-form-item>-->
                            <el-form-item style="margin: 10px 0; text-align: right">
                                <el-button type="text" @click="$router.push('/')"><<  返回首页  </el-button>
                                <el-button type="primary" size="small"  autocomplete="off" @click="login">登录</el-button>
                                <!--<el-button type="text" @click="$router.push('/register')">前往注册 >> </el-button>-->
                                <el-button type="warning" size="small"  autocomplete="off" @click="$router.push('/register')">注册</el-button>
                            </el-form-item>
                        </el-form>
                    </div>
                </div>
            </div>

            <video :style="fixStyle" autoplay loop muted class="fillWidth" v-on:canplay="canplay">
                <source src="../assets/sea.mp4" type="video/mp4"/>
                浏览器不支持 video 标签，建议升级浏览器。
            </video>
        </div>


    </div>
</template>

<script>
    import {setRoutes} from "../router";
    import Background from "../views/front/Background";
    import ValidCode from "../components/ValidCode";
    export default {
        name: "Login",
        data() {
            return {
                vedioCanPlay: false,
                fixStyle: '',
                user: {},
                rules: {
                    username: [
                        {required: true, message: '请输入用户名', trigger: 'blur'},
                        {min: 3, max: 20, message: '长度在 3 到 20 个字符', trigger: 'blur'}
                    ],
                    password: [
                        {required: true, message: '请输入密码', trigger: 'blur'},
                        {min: 1, max: 20, message: '长度在 1 到 20 个字符', trigger: 'blur'}
                    ],
                },
                ValidCode:'',
            }
        },
        mounted() {
            sessionStorage.removeItem("user")

            window.onresize = () => {
                const windowWidth = document.body.clientWidth;
                const windowHeight = document.body.clientHeight;
                const windowAspectRatio = windowHeight / windowWidth;
                let videoWidth;
                let videoHeight;
                if (windowAspectRatio < 0.5625) {
                    videoWidth = windowWidth;
                    videoHeight = videoWidth * 0.5625;
                    this.fixStyle = {
                        height: windowWidth * 0.5625 + 'px',
                        width: windowWidth + 'px',
                        'margin-bottom': (windowHeight - videoHeight) / 2 + 'px',
                        'margin-left': 'initial'
                    }
                } else {
                    videoHeight = windowHeight;
                    videoWidth = videoHeight / 0.5625;
                    this.fixStyle = {
                        height: windowHeight + 'px',
                        width: windowHeight / 0.5625 + 'px',
                        'margin-left': (windowWidth - videoWidth) / 2 + 'px',
                        'margin-bottom': 'initial'
                    }
                }
            }
            window.onresize()
        },
        components:{
            'v-background': Background,
            ValidCode,
        },
        methods: {
            canplay() {
                this.vedioCanPlay = true
            },
            createValidCode(data){
                this.validCode = data
            },
            login() {
                this.$refs['userForm'].validate((valid) => {
                    if (valid) {  // 表单校验合法
                        if(!this.user.validCode){
                            this.$message.error("请输入验证码");
                            return
                        }
                        if(this.user.validCode.toLowerCase() !== this.validCode.toLowerCase()){
                            this.$message.error("验证码错误");
                            return
                        }

                        this.request.post("/user/login", this.user).then(res => {
                            if (res.code === '200') {
                                localStorage.setItem("user", JSON.stringify(res.data));  // 存储用户信息到浏览器
                                localStorage.setItem("menus", JSON.stringify(res.data.menus)); // 存储用户信息到浏览器
                                // 动态设置当前用户的路由
                                setRoutes();

                                this.$message.success("登录成功");
                                // console.log(this.$route.path);
                                // this.$router.go(-1)
                                this.$router.push("/home")

                                // if (this.$route.path == ("/register")) {
                                //     this.$router.push("/home")
                                // }


                            } else {
                                this.$message.error(res.msg)
                            }
                        })
                    }
                });
            }
        }
    }
</script>

<style>
    .login {
        width: 98vw;
        height: 90vh;
    }
    .login-box {
        top: 0;
        bottom: 15vw;
        left: 0;
        right: 0;
        margin: auto;
    }
    .homepage-hero-module,
    .video-container {
        position: relative;
        height: 100vh;
        overflow: hidden;
    }

    .video-container .poster img{
        z-index: 0;
        position: absolute;
    }

    .video-container .filter {
        z-index: 1;
        position: absolute;
        /*background: rgba(0, 0, 0, 0.4);*/
        width: 100%;
    }

    .fillWidth {
        width: 100%;
    }
</style>
